import { SxPropsTypes } from '../../../../theme/MuiThemeProvider/types';

export const styles: SxPropsTypes = {
  listWrap: {
    paddingBottom: '24px',
    display: 'grid',
    gap: '16px',
  },
};
